export const MARKET_ANALYSIS_PAGE_SLUG = 'market-analysis';
